import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import clsx from 'clsx';
import VideoThumbnail from "./VideoThumbnailPic";
import VideoThumbnailPic from "./VideoThumbnailPic";

export default function Thumbnail({
  image, selectedImage, callbacks, productGroup, className,
  zIndex = 0, ...props
}) {

  let isVideo = (image.flavour === 'video');
//    return <VideoThumbnail image={image} callbacks={callbacks} {...props} />;

  let thumb = image.thumb || image.sm || image.md;
  let caption = image.title || productGroup?.name;
  let selected = selectedImage?.i && (selectedImage?.i === image?.i);

  let handleClick = (evt) => {
    callbacks.setSelectedImage(image);
  }

  className = clsx(className,  // mr-1 mb-1
    "relative inline-block md:block cursor-pointer border-2 h-full",
    selected ? 'border-brand-dark' : 'border-paper' //border-paper
  );

  return <a className={className} onClick={handleClick}>
    <img className="thumb max-h-full h-full object-cover"
      src={thumb} alt={caption}
      width="125" height="86"
    />
    {isVideo && <div className="absolute inset-0">
      <span className="block centered text-3xl md:text-4xl fa fa-play-circle text-white"/>
    </div>}
  </a>
}

